/**
 * Common Copy
 * 
 * Shared copy elements used across multiple pages and components
 * including buttons, error messages, loading states, and common UI text.
 */

export const commonCopy = {
  buttons: {
    // Common button text will be added here as we expand the copy system
    // Examples: save, cancel, submit, etc.
  },
  
  errors: {
    // Common error messages will be added here as we expand
    // Examples: network errors, validation errors, etc.
  },
  
  loading: {
    // Loading state text will be added here as we expand
    // Examples: "Loading...", "Please wait...", etc.
  },
  
  states: {
    // Empty states, success messages, etc. will be added here
  },
  
  shareMusicPanel: {
    dashboard: {
      headerText: "Share what's moving you",
      explainerText: "Comment on a track • Write a review • Add to Listening Room",
      urlPlaceholder: "Paste album or track URL...",
    },
    listeningRoom: {
      headerText: "Add to The Listening Room",
      explainerText: "Curate complete albums that reward intentional listening and deserve discovery",
      urlPlaceholder: "Paste album URL...",
    },
  },
};